<template>
  <el-dialog title="上传" :visible.sync="uploadDialogs" width="30%" :before-close="handleClose" v-if="uploadDialogs">
    <div style="text-align: center;">
      <el-upload
        class="upload-demo"
        drag
        :http-request="upFun"
        :action='api.uploadUrl + "/5ce7e4f35dc2b"'
        multiple
        :headers="upHeaders"
        :data="upData"
        :limit='1'
        accept=".pdf,.doc,.docx"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">仅支持附件＜20M格式PDF、docx、xlsx</div>
      </el-upload>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    uploadDialog: Boolean
  },
  data() {
    return {
        uploadDialogs: false,
        upHeaders: {
          'access-token': JSON.parse(this.Cookies.get('AccessToken')).access_token,
          version: 'v3.0'
        },
        upData: {
          is_save_old_file_name: 1
        }
    };
  },
  watch: {
    uploadDialog() {
        this.uploadDialogs = this.uploadDialog
    }
  },
  methods: {
    handleClose() {
      this.uploadDialogs = false;
      this.$emit('closeUpload',this.uploadDialogs)
    },

    // 上传
    upFun(f) {
      let obj = {
        file: f.file
      }

      // 上传
      this.api.uploadf('/5ce7e4f35dc2b?is_save_old_file_name=1',obj).then(r=>{
        let fileUrl = r.data.fileUrl
        // 获取vid
        this.api.get('/5cf3c3436edc5', {}).then(r=>{
          let vid = r.data.list[0].vid
          // 获取自己的简历
          this.api.get('/5cf3c3dd5d8d3', { vid }).then(vr=>{
            let vobj = vr.data
            vobj.attach = fileUrl
            vobj.job_confim = JSON.parse(vobj.job_confim)
            vobj.selftags = JSON.parse(vobj.selftags)
            this.api.post('/5cf3c448ad3db',vobj).then(r=>{
              location.reload()
              this.$message({
                message: '上传成功',
                type: 'success'
              });
              this.uploadDialogs = false
              this.$emit('uploadSuccess', true)
            })
          })
        })
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/upload/index.vue